'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
require('../../../components/Card/Card.js');
var CardBody = require('../../../components/Card/CardBody.js');
require('../../../components/Card/CardFooter.js');
require('../../../components/Card/CardHeader.js');
require('../../../components/Card/CardHeaderAddon.js');
require('../../../components/Card/CardEditButton.js');
require('../../../components/Card/CardHeaderEditButton.js');
require('../../../components/Card/CardFooterEditButton.js');
require('../../../components/Card/CardEmpty.js');
var useEditCard = require('./useEditCard.js');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * `Edit card body
 *
 * Will be rendered if the card is not in empty mode and should contain
 * editables.
 */
var EditCardBody = react.forwardRef(function (props, ref) {
  var _useEditCardContext = useEditCard.useEditCardContext(),
    isEmpty = _useEditCardContext.isEmpty,
    isEditing = _useEditCardContext.isEditing;
  if (isEmpty && !isEditing) return null;
  return /*#__PURE__*/React__default["default"].createElement(CardBody.CardBody, _extends__default["default"]({
    ref: ref
  }, props));
});
EditCardBody.displayName = 'EditCardBody';
exports.EditCardBody = EditCardBody;